import { defineComponent as d, openBlock as t, createElementBlock as o, mergeProps as u, unref as e, renderSlot as p, createElementVNode as H, createCommentVNode as v } from "vue";
import { useScalarIcon as i } from "../hooks/useScalarIcon.js";
const V = { key: 0 }, m = { key: 1 }, g = { key: 2 }, Z = { key: 3 }, M = { key: 4 }, f = { key: 5 }, k = {
  name: "ScalarIconCurrencyRub"
}, _ = /* @__PURE__ */ d({
  ...k,
  props: {
    label: {},
    weight: {}
  },
  setup(l) {
    const r = l, { bind: s, weight: n } = i(r);
    return (h, a) => (t(), o("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(s)), [
      p(h.$slots, "default"),
      e(n) === "bold" ? (t(), o("g", V, a[0] || (a[0] = [
        H("path", { d: "M148,156a64,64,0,0,0,0-128H88A12,12,0,0,0,76,40v92H56a12,12,0,0,0,0,24H76v16H56a12,12,0,0,0,0,24H76v20a12,12,0,0,0,24,0V196h44a12,12,0,0,0,0-24H100V156ZM100,52h48a40,40,0,0,1,0,80H100Z" }, null, -1)
      ]))) : e(n) === "duotone" ? (t(), o("g", m, a[1] || (a[1] = [
        H("path", {
          d: "M200,92a52,52,0,0,1-52,52H88V40h60A52,52,0,0,1,200,92Z",
          opacity: "0.2"
        }, null, -1),
        H("path", { d: "M148,152a60,60,0,0,0,0-120H88a8,8,0,0,0-8,8v96H56a8,8,0,0,0,0,16H80v16H56a8,8,0,0,0,0,16H80v32a8,8,0,0,0,16,0V184h48a8,8,0,0,0,0-16H96V152ZM96,48h52a44,44,0,0,1,0,88H96Z" }, null, -1)
      ]))) : e(n) === "fill" ? (t(), o("g", g, a[2] || (a[2] = [
        H("path", { d: "M168,104a24,24,0,0,1-24,24H112V80h32A24,24,0,0,1,168,104Zm64,24A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-48-24a40,40,0,0,0-40-40H104a8,8,0,0,0-8,8v56H88a8,8,0,0,0,0,16h8v16H88a8,8,0,0,0,0,16h8v16a8,8,0,0,0,16,0V176h40a8,8,0,0,0,0-16H112V144h32A40,40,0,0,0,184,104Z" }, null, -1)
      ]))) : e(n) === "light" ? (t(), o("g", Z, a[3] || (a[3] = [
        H("path", { d: "M148,150a58,58,0,0,0,0-116H88a6,6,0,0,0-6,6v98H56a6,6,0,0,0,0,12H82v20H56a6,6,0,0,0,0,12H82v34a6,6,0,0,0,12,0V182h50a6,6,0,0,0,0-12H94V150ZM94,46h54a46,46,0,0,1,0,92H94Z" }, null, -1)
      ]))) : e(n) === "regular" ? (t(), o("g", M, a[4] || (a[4] = [
        H("path", { d: "M148,152a60,60,0,0,0,0-120H88a8,8,0,0,0-8,8v96H56a8,8,0,0,0,0,16H80v16H56a8,8,0,0,0,0,16H80v32a8,8,0,0,0,16,0V184h48a8,8,0,0,0,0-16H96V152ZM96,48h52a44,44,0,0,1,0,88H96Z" }, null, -1)
      ]))) : e(n) === "thin" ? (t(), o("g", f, a[5] || (a[5] = [
        H("path", { d: "M148,36H88a4,4,0,0,0-4,4V140H56a4,4,0,0,0,0,8H84v24H56a4,4,0,0,0,0,8H84v36a4,4,0,0,0,8,0V180h52a4,4,0,0,0,0-8H92V148h56a56,56,0,0,0,0-112Zm0,104H92V44h56a48,48,0,0,1,0,96Z" }, null, -1)
      ]))) : v("", !0)
    ], 16));
  }
});
export {
  _ as default
};
